import msgboxVue from './index.vue';
// 定义插件对象
const Message = {};
// vue的install方法，用于定义vue插件
Message.install = (Vue, options) => {
  const MessageBoxInstance = Vue.extend(msgboxVue);
  let currentMsg;
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new MessageBoxInstance();
    const msgBoxEl = currentMsg.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$message = {
    showMsgBox(options) {
      initInstance();
      Object.assign(currentMsg, options);
      currentMsg.visible = true;
    }
  };
};
export default Message;



// WEBPACK FOOTER //
// ./src/components/common/message/index.js